import { render, staticRenderFns } from "./EvHubForm.vue?vue&type=template&id=38e72f52"
import script from "./EvHubForm.vue?vue&type=script&lang=js"
export * from "./EvHubForm.vue?vue&type=script&lang=js"
import style0 from "./EvHubForm.vue?vue&type=style&index=0&id=38e72f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports